(() => {
  const root = window.Shopify?.routes?.root || '/';
  const $ = (selector, parent = document) => parent.querySelector(selector);
  const status = $('#ThemeStatus');
  const announce = (message) => { if (status) status.textContent = message; };
  const openDialog = (dialog) => { if (dialog && !dialog.open) dialog.showModal(); };
  const header = $('[data-header]');
  const updateHeader = () => header?.classList.toggle('scrolled', window.scrollY > 40);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
  document.addEventListener('click', (event) => {
    const target = event.target.closest('a,button');
    if (!target) return;
    if (target.matches('[data-open-cart]')) { event.preventDefault(); openDialog($('#CartDrawer')); }
    if (target.matches('[data-open-search]')) { openDialog($('#SearchDialog')); $('#PredictiveSearch')?.focus(); }
    if (target.matches('[data-close-dialog]')) target.closest('dialog')?.close();
    if (target.matches('[data-video-toggle]')) {
      const video = $('video', target.parentElement);
      if (!video) return;
      if (video.paused) { video.play(); target.textContent = 'Pause video'; target.setAttribute('aria-label', 'Pause campaign video'); }
      else { video.pause(); target.textContent = 'Play video'; target.setAttribute('aria-label', 'Play campaign video'); }
    }
  });
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
  });
  document.querySelectorAll('.mega-menu').forEach(menu => {
    menu.addEventListener('toggle', () => { if (menu.open) document.querySelectorAll('.mega-menu').forEach(other => { if (other !== menu) other.open = false; }); });
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('details[open]').forEach(item => { item.open = false; }); });
  document.addEventListener('click', event => { document.querySelectorAll('.mega-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; }); });
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pauseVideos = () => {
    if (reduceMotion.matches) document.querySelectorAll('.campaign video').forEach(video => {
      video.pause();
      const button = $('[data-video-toggle]', video.parentElement);
      if (button) { button.textContent = 'Play video'; button.setAttribute('aria-label', 'Play campaign video'); }
    });
  };
  pauseVideos();
  document.addEventListener('shopify:section:load', pauseVideos);
  const cartRequest = async (path, data) => {
    const response = await fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Your bag could not be updated. Please try again.');
    return result;
  };
  const refreshCart = async () => {
    const [cartResponse, drawerResponse] = await Promise.all([
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }),
      fetch(root + '?section_id=cart-drawer')
    ]);
    if (!cartResponse.ok || !drawerResponse.ok) throw new Error('Unable to refresh your bag. Open the bag page to continue.');
    const cart = await cartResponse.json();
    const html = await drawerResponse.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = $('[data-cart-content]', parsed);
    if (content) $('[data-cart-content]').innerHTML = content.innerHTML;
    document.querySelectorAll('[data-cart-count]').forEach(count => { count.textContent = cart.item_count; });
    announce('Your bag has been updated.');
  };
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.product-form')) return;
    event.preventDefault();
    const button = $('[data-add-button]', form);
    const error = $('[data-product-error]', form);
    button.disabled = true;
    error.textContent = '';
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'This piece could not be added.');
      await refreshCart();
      openDialog($('#CartDrawer'));
    } catch (e) { error.textContent = e.message; }
    finally { button.disabled = false; }
  });
  document.addEventListener('click', async event => {
    const remove = event.target.closest('#CartDrawer [data-remove-key]');
    if (!remove) return;
    event.preventDefault();
    try { await cartRequest('cart/change.js', { id: remove.dataset.removeKey, quantity: 0 }); await refreshCart(); }
    catch (e) { announce(e.message); alert(e.message); }
  });
  document.addEventListener('change', async event => {
    const input = event.target;
    if (!input.matches('#CartDrawer [data-cart-key]')) return;
    input.disabled = true;
    try { await cartRequest('cart/change.js', { id: input.dataset.cartKey, quantity: Math.max(0, Number(input.value)) }); await refreshCart(); }
    catch (e) { announce(e.message); alert(e.message); input.disabled = false; }
  });
  const product = $('[data-product]');
  if (product) {
    const variants = JSON.parse($('[data-product-variants]', product).textContent);
    const select = $('[data-variant-select]', product);
    const options = $('[data-options]', product);
    if (options) {
      options.hidden = false;
      select.hidden = true;
      document.querySelector('label[for="VariantSelect"]').hidden = true;
    }
    const updateVariant = (variant) => {
      const button = $('[data-add-button]', product);
      const error = $('[data-product-error]', product);
      button.disabled = !variant?.available;
      button.textContent = variant?.available ? 'Add to Bag' : variant ? 'Sold out' : 'Unavailable';
      error.textContent = variant ? '' : 'This combination is unavailable. Choose another option.';
      if (!variant) return;
      select.value = variant.id;
      $('[data-product-price]', product).textContent = variant.price;
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      if (variant.image) {
        const image = $('.product-gallery img', product);
        if (image) { image.src = variant.image; image.removeAttribute('srcset'); }
      }
    };
    product.addEventListener('change', e => {
      if (e.target.matches('[data-option-position]')) {
        const chosen = [...product.querySelectorAll('[data-options] fieldset')].map(field => $('input:checked', field)?.value);
        updateVariant(variants.find(variant => variant.options.every((value, index) => value === chosen[index])));
      } else if (e.target === select) updateVariant(variants.find(variant => String(variant.id) === select.value));
    });
  }
  let searchTimer, searchController;
  $('[data-predictive-input]')?.addEventListener('input', event => {
    clearTimeout(searchTimer);
    searchController?.abort();
    const input = event.target;
    const results = $('#PredictiveResults');
    if (input.value.trim().length < 2) { results.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
    searchTimer = setTimeout(async () => {
      searchController = new AbortController();
      try {
        const query = new URLSearchParams({ q: input.value, 'resources[type]': 'product', 'resources[limit]': '6', section_id: 'predictive-search' });
        const response = await fetch(root + 'search/suggest?' + query, { signal: searchController.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        results.innerHTML = html;
        input.setAttribute('aria-expanded', 'true');
      } catch (e) { if (e.name !== 'AbortError') { results.textContent = 'Press Search to see all results.'; input.setAttribute('aria-expanded', 'false'); } }
    }, 250);
  });
  document.querySelectorAll('[data-address-country]').forEach(select => {
    const updateProvinces = () => {
      const provinces = JSON.parse(select.selectedOptions[0]?.dataset.provinces || '[]');
      const province = document.getElementById(select.dataset.provinceTarget);
      province.replaceChildren();
      provinces.forEach(([value, title]) => { const option = new Option(title, value); option.selected = value === province.dataset.default; province.append(option); });
      province.closest('[data-province-wrapper]').hidden = provinces.length === 0;
    };
    select.value = select.dataset.default;
    updateProvinces();
    select.addEventListener('change', updateProvinces);
  });
  document.addEventListener('submit', e => { if (e.target.matches('[data-delete-address]') && !confirm('Delete this address?')) e.preventDefault(); });
})();
